// extracted by mini-css-extract-plugin
export var buttonBox = "flex-bar-module--button-box--b812b";
export var dropdown = "flex-bar-module--dropdown--4b442";
export var flexBar = "flex-bar-module--flex-bar--7b567";
export var open = "flex-bar-module--open--d17a8";
export var visibleBox = "flex-bar-module--visible-box--e442e";